import React from 'react';
import { Outlet } from 'react-router';

const Body:React.FunctionComponent = () => {

  return (
    <div className="container-fluid">
    <Outlet />
    </div>
  );
}

export { Body as AdminBody }